import golferEpic from "./golfer-fetch";
import golferScoresEpic from "./golfer-scores-fetch";
import { combineEpics } from "redux-observable";

export default combineEpics(golferEpic, golferScoresEpic);
